// ── PALETTE (copia locale — identica a App.js) ────────────────────────────────
const P = {
  bg:"#080B14", card:"#0D1020", border:"#1D2238",
  gold:"#E9622A", goldGlow:"rgba(233,98,42,0.12)", goldBorder:"rgba(233,98,42,0.30)",
  text:"#EBE8F5", muted:"#8A8EAE", secondary:"#B4B7D0",
  green:"#5BB87A", yellow:"#E9622A", red:"#C46B6B", blue:"#5A82B8", purple:"#a78bfa",
  sidebar:"#060810", card2:"#111525", card3:"#161B2E",
  borderSubtle:"#141829", borderStrong:"#2A3055"
};

export const mc = (m, colors) => colors[m] || P.gold;

export function cellInfo(v) {
  if(!v) return {bg:"transparent",color:P.muted,label:"·",border:"transparent"};
  // Presenze con durata
  if(v==="45p") return {bg:"rgba(74,222,128,.08)",color:"#86efac",label:"45'", border:"rgba(74,222,128,.25)"};
  if(v==="1p") return {bg:"rgba(74,222,128,.13)",color:"#4ade80",label:"1h", border:"rgba(74,222,128,.35)"};
  if(v==="2p") return {bg:"rgba(74,222,128,.22)",color:"#22c55e",label:"1½", border:"rgba(74,222,128,.5)"};
  if(v==="3p") return {bg:"rgba(74,222,128,.35)",color:"#16a34a",label:"2h", border:"rgba(74,222,128,.7)"};
  // Legacy 'p' — backward compat
  if(v==="p")  return {bg:"rgba(74,222,128,.18)",color:P.green, label:"1h", border:"rgba(74,222,128,.4)"};
  if(v==="a")  return {bg:"rgba(248,113,113,.18)",color:P.red,    label:"A",  border:"rgba(248,113,113,.4)"};
  // Maestro assente (più evidente dell'assenza allievo)
  if(v==="m")  return {bg:"rgba(220,38,38,.35)",  color:"#ef4444",label:"✕",  border:"rgba(220,38,38,.75)"};
  // Recupero con durata
  if(v==="1r") return {bg:"rgba(251,191,36,.13)", color:"#fbbf24",label:"1h", border:"rgba(251,191,36,.35)"};
  if(v==="2r") return {bg:"rgba(251,191,36,.22)", color:"#f59e0b",label:"1½", border:"rgba(251,191,36,.5)"};
  if(v==="3r") return {bg:"rgba(251,191,36,.35)", color:"#d97706",label:"2h", border:"rgba(251,191,36,.7)"};
  // Legacy 'r' — backward compat
  if(v==="r")  return {bg:"rgba(251,191,36,.18)", color:P.yellow, label:"1h", border:"rgba(251,191,36,.4)"};
  if(v==="v")  return {bg:"rgba(96,165,250,.18)", color:P.blue,   label:"▷", border:"rgba(96,165,250,.4)"};
  return {bg:"rgba(167,139,250,.18)",color:P.purple,label:"?",border:"rgba(167,139,250,.4)"};
}

// Ore di lezione dallo stato presenza (P e R contano entrambi come ore)
export const oreFromStato = (v) => {
  if(v==="45p") return 0.75;
  if(v==="1p"||v==="p"||v==="1r"||v==="r") return 1;
  if(v==="2p"||v==="2r") return 1.5;
  if(v==="3p"||v==="3r") return 2;
  return 0;
};

export const getAllievoCorsi = (a) =>
  a.corsi && a.corsi.length > 0
    ? a.corsi
    : [{maestro: a.maestro, strumento: '', retta: a.retta||0, quota_m: null}];

// Restituisce la retta effettiva tenendo conto del trattamento speciale
export const effectiveRetta = (a) =>
  getAllievoCorsi(a).reduce((s,c) => s + c.retta, 0);

export const getImportoAllievo = (a) => effectiveRetta(a);
